
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.2 10.3c-.1.4-.5.7-.9.7H4.8c-.5 0-.9-.3-1-.8L2.2 4c-.1-.6-.6-1-1.2-1H.4C.2 3 0 2.8 0 2.6V1.4c0-.2.2-.4.4-.4h1.4c1 0 1.9.7 2.1 1.7l1.5 6.1c.1.1.3.2.4.2h6.5c.1 0 .2-.1.3-.2l1.1-3.4c.1-.2 0-.4-.2-.4H7.4c-.2 0-.4-.2-.4-.4V3.4c0-.2.2-.4.4-.4H15c.6 0 1 .4 1 1v1l-1.8 5.3zM4.5 13c.8 0 1.5.7 1.5 1.5S5.3 16 4.5 16 3 15.3 3 14.5 3.7 13 4.5 13zm7 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z"}})])
          )
        }
      }
    